import { useCallback, useEffect } from 'react'
import apiFetch from '@wordpress/api-fetch'
import { xorDecipherAndParse } from '../../shared/utils'

import type { UpdatePageHeaderEventType } from '../../page-header/block'
import { CONSTS } from '../../config/const'

const replaceCanonical = (newHref: string) => {
    const canonical = document.querySelector('link[rel="canonical"]')
    if (canonical !== null) {
        canonical.setAttribute('href', newHref)
    }
}

const replaceDescription = (newDesc: string) => {
    const description = document.querySelector('meta[name="description"]')
    if (description !== null) {
        description.setAttribute('content', newDesc)
    }
}

export const useTunnelUpdateSeo = () => {
    const onPopState = useCallback(async (e: PopStateEvent) => {
        // Update only if it's a competition params state
        if (e.state?.competitionParams) {
            replaceCanonical(window.location.href)
            try {
                const queryParams = new URLSearchParams(e.state)
                const fetchedAttributes = await apiFetch<any>({
                    path: `competitions/v1/tunnel_seo?${queryParams.toString()}`,
                })

                const newSeoData = xorDecipherAndParse(fetchedAttributes)
                window.document.title = newSeoData.head?.meta_title
                replaceDescription(newSeoData.head?.description)
                const pageHeaderEvent = new CustomEvent<UpdatePageHeaderEventType>(
                    CONSTS.UPDATE_PAGE_HEADER_EVENT_NAME,
                    {
                        detail: {
                            title: newSeoData.head?.H1,
                            breadcrumb: newSeoData.breadcrumb,
                        },
                    },
                )
                dispatchEvent(pageHeaderEvent)
            } catch {}
        }
    }, [])

    useEffect(() => {
        window.addEventListener('popstate', onPopState)
        return () => {
            window.removeEventListener('popstate', onPopState)
        }
    }, [onPopState])
}
